import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const usersManagementReducer = foxGridReducer(gridNames.usersManagement);

export default usersManagementReducer;
